/**
 * Hook for getting canonical URLs in client components
 */
import { useEffect, useState } from "react";
import { getCanonicalUrl } from "@/utils/canonical";

/**
 * Custom hook to get the canonical URL for the current page
 * @param customPath - Optional custom path to use instead of current pathname
 * @param lang - Current language
 * @returns The canonical URL
 */
export function useCanonicalUrl(customPath?: string, lang?: string): string {
  // Start empty to avoid injecting a wrong default canonical before computing
  const [canonicalUrl, setCanonicalUrl] = useState<string>("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      const pathname = customPath || window.location.pathname;
      const canonical = getCanonicalUrl(pathname, lang);
      setCanonicalUrl(canonical);
    }
  }, [customPath, lang]);

  return canonicalUrl;
}
